import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'

// Root wrapper for the form
export const StyledFormWrapper = styled(Box)({
    '& .MuiTextField-root': {
        width: '100%',
    },
    '& label.Mui-focused': {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    '& .MuiInput-root': {
        '&:after': {
            borderBottomColor: 'rgba(0, 0, 0, 0.54)',
        },
        '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: 'rgba(0, 0, 0, 0.54)',
        },
      },
})

export const OutlinedPrimaryButton = styled(Button)({
    color: '#1c6e2f',
    backgroundColor: '#fff',
    border: '1px solid #1c6e2f',
    borderRadius: '40px',
    '&:hover': {
        backgroundColor: '#fff',
        border: '1px solid #1c6e2f',
    },
})

export const ContainedPrimaryButton = styled(Button)({
    color: '#fff',
    backgroundColor: '#1c6e2f',
    border: '1px solid #1c6e2f',
    borderRadius: '40px',
    '&:hover': {
        backgroundColor: '#1c6e2f',
    },
    '&:disabled': {
        border: 'none',
    },
})

export const StyledPopperWrapper = styled(Box)({
    '& .MuiInputBase-root': {
        paddingRight: '0px !important',
    },
})

export const StyledPaper = styled(Paper)({
    backgroundColor: 'rgba(245, 245, 245, 1)',
    height: '100%',
})
